import clsx from 'clsx';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';

import { useCorporateLeadCreate } from '../../hooks';
import { getImgxSrc } from '../../utils/images';
import { Button } from '../BaseUI';
import { DropdownField, TextField } from '../FormFields';
import schema from './schema';
import styles from './styles.module.scss';

const NUMBER_OF_USER_OPTIONS = [
  { label: 'Less than 10', value: '< 10' },
  { label: '10 - 25', value: '10 - 25' },
  { label: '26 - 100', value: '26 - 100' },
  { label: '100 - 1,000', value: '100 - 1000' },
  { label: 'Greater than 1,000', value: '> 1000' },
];

interface FormProps {
  name: string;
  companyName: string;
  email: string;
  jobTitle: string;
  possibleNumberOfUsers: {
    label: string;
    value: string;
  };
}

const INITIAL_VALUES: FormProps = {
  name: '',
  companyName: '',
  email: '',
  jobTitle: '',
  possibleNumberOfUsers: {
    label: '',
    value: '',
  },
};

const HeaderSection = () => {
  const { mutateAsync: createCorpoateLead } = useCorporateLeadCreate();
  const [showSuccessMessage, setSuccessMessage] = useState(false);
  const [existingEntries, setExistingEntries] = useState(false);
  const handleSubmit = async ({ name, companyName, email, jobTitle, possibleNumberOfUsers }) => {
    const sanitizedParams = {
      corporate_lead: {
        name,
        company_name: companyName,
        email,
        job_title: jobTitle,
        possible_number_of_users: possibleNumberOfUsers.value,
      },
    };
    const resp = await createCorpoateLead(sanitizedParams);
    if (resp.success) {
      setExistingEntries(resp.existingEntries);
      setSuccessMessage(!showSuccessMessage);
    }
  };

  return (
    <div className={styles.topContainer} id="topContainer">
      <div className={clsx(styles.headerWrapper, 'container')}>
        <div className={clsx(styles.headerContainer, 'row')}>
          <div className="col-sm-12 col-md-6">
            <div className={styles.tag}>team opportunity</div>
            <div className={styles.header}>Group Subscriptions</div>
            <div className={styles.description}>
              The Information offers essential, original journalism on Silicon Valley and its impact
              on the world.
            </div>
            <div className={styles.heroImg}>
              <img src={getImgxSrc('corporate/Hero.png', true)} />
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className={styles.formWrapper}>
              <div className={styles.topBorder} />
              {!showSuccessMessage ? (
                <div className={styles.form}>
                  <div className={styles.formHeader}>Connect with our Team</div>
                  <Formik
                    validationSchema={schema}
                    initialValues={INITIAL_VALUES}
                    onSubmit={handleSubmit}
                  >
                    {(formik) => (
                      <Form onSubmit={formik.handleSubmit}>
                        <TextField name="name" placeholder="Full Name" />
                        <TextField name="companyName" placeholder="Company" />
                        <TextField name="jobTitle" placeholder="Title" />
                        <TextField name="email" placeholder="Email" />
                        <div className={styles.dropDown}>
                          <DropdownField
                            name="possibleNumberOfUsers"
                            options={NUMBER_OF_USER_OPTIONS}
                            placeholder="Potential Number of Users"
                            isClearable={false}
                          />
                        </div>
                        <div className={styles.submitBtn}>
                          <Button
                            variant="primary"
                            width="full"
                            type="submit"
                            disabled={!formik.isValid || formik.isSubmitting || !formik.dirty}
                          >
                            Contact Us
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              ) : (
                <div className={styles.confirmMessageContainer}>
                  <div className={styles.formHeader}>Thank you for reaching out!</div>
                  <div className={styles.confirmEmailImage}>
                    <img src={getImgxSrc('corporate/ConfirmEmail.svg', true)} />
                  </div>
                  {existingEntries ? (
                    <div className={styles.confirmEmailMessage}>
                      Thank you for filling out our form. We already have your details and will be
                      reaching out shortly. If you would like to send us any further information,
                      you can reach out to us via email at
                    </div>
                  ) : (
                    <div className={styles.confirmEmailMessage}>
                      Someone from our team will be in touch with you shortly. If you have any
                      immediate questions, please reach out to
                    </div>
                  )}
                  <div className={styles.confirmCorporateEmail}>
                    <a href="mailto:corporate@theinformation.com">corporate@theinformation.com</a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
